import { all, fork, takeLatest } from 'redux-saga/effects';
import { sliceName } from '../redux/toolsSlice';
import * as Sagas from './saga';

function* watchFetchCreateJobCompanysList() {
    yield takeLatest(
        `${sliceName}/fetchCreateJobCompanysList`,
        Sagas.fetchCreateJobCompanysListSaga
    );
}

function* watchFetchCreateJobQuestionsCategories() {
    yield takeLatest(
        `${sliceName}/fetchCreateJobQuestionsCategories`,
        Sagas.fetchCreateJobQuestionsCategoriesSaga
    );
}

function* watchPostCreateCompany() {
    yield takeLatest(
        `${sliceName}/postCreateCompany`,
        Sagas.postCreateCompanySaga
    );
}

function* watchFetchCompanyCategories() {
    yield takeLatest(
        `${sliceName}/fetchCompanyCategories`,
        Sagas.fetchCompanyCategoriesSaga
    );
}

function* watchFetchActiveChatQuestions() {
    yield takeLatest(
        `${sliceName}/fetchActiveChatQuestions`,
        Sagas.fetchActiveChatQuestionsSaga
    );
}

function* watchFetchChatsList() {
    yield takeLatest(`${sliceName}/fetchChatsList`, Sagas.fetchChatsListSaga);
}

function* watchFetchChatHistory() {
    yield takeLatest(
        `${sliceName}/fetchActiveChatHistory`,
        Sagas.fetchActiveChatHistorySaga
    );
}

function* watchSendCreateChatMessage() {
    yield takeLatest(
        `${sliceName}/sendCreateChatMessage`,
        Sagas.sendCreateChatMessageSaga
    );
}

function* watchHandleCreateChatSuccessMessage() {
    yield takeLatest(
        `${sliceName}/handleCreateChatSuccessMessage`,
        Sagas.handleCreateChatSuccessMessageSaga
    );
}

function* watchHandleCreateChatFailedMessage() {
    yield takeLatest(
        `${sliceName}/handleCreateChatFailedMessage`,
        Sagas.handleCreateChatFailedMessageSaga
    );
}

function* watchPostCompanyQuestionAnswer() {
    yield takeLatest(
        `${sliceName}/postCompanyQuestionAnswer`,
        Sagas.postCompanyQuestionAnswerSaga
    );
}

function* watchHandleChatReplyFromAI() {
    yield takeLatest(
        `${sliceName}/handleChatReplyFromAI`,
        Sagas.handleChatReplyFromAISaga
    );
}

function* watchSendChatMessage() {
    yield takeLatest(`${sliceName}/sendChatMessage`, Sagas.sendChatMessageSaga);
}

function* watchHandleSendChatMessageSuccess() {
    yield takeLatest(
        `${sliceName}/handleSendChatMessageSuccess`,
        Sagas.handleSendChatMessageSuccessSaga
    );
}
function* watchHandleSendChatMessageFailed() {
    yield takeLatest(
        `${sliceName}/handleSendChatMessageFailed`,
        Sagas.handleSendChatMessageFailedSaga
    );
}

function* watchFetchCompanyQuestionsHistory() {
    yield takeLatest(
        `${sliceName}/fetchCompanyQuestionsHistory`,
        Sagas.fetchCompanyQuestionsHistorySaga
    );
}

export function* toolsSagas() {
    yield all([
        fork(watchFetchCreateJobCompanysList),
        fork(watchFetchCreateJobQuestionsCategories),
        fork(watchPostCreateCompany),
        fork(watchFetchCompanyCategories),
        fork(watchFetchActiveChatQuestions),
        fork(watchFetchChatsList),
        fork(watchFetchChatHistory),
        fork(watchSendCreateChatMessage),
        fork(watchHandleCreateChatSuccessMessage),
        fork(watchHandleCreateChatFailedMessage),
        fork(watchPostCompanyQuestionAnswer),
        fork(watchHandleChatReplyFromAI),
        fork(watchSendChatMessage),
        fork(watchHandleSendChatMessageSuccess),
        fork(watchHandleSendChatMessageFailed),
        fork(watchFetchCompanyQuestionsHistory),
    ]);
}
